import React from "react";
import "./DataTable.css";
import { Space, Table, Tag } from "antd";

const DataTable = (props) => {
  const { rows, columns, showPagination,pageSize, onRowClick, selectedRow,loading } = props;
  const hightlightRow = (record) => {
     return record?.id === selectedRow?.id  ? 'selected-row' : ''
  };

  //Maintaining table height without records while loading
  const loadingEmpty = (loading && { emptyText: <div style={{ minHeight: "100px" }}></div> })

  return (
    <div className="data-table">
      <Table
        scroll={{ x: "100%" }}
        columns={columns}
        dataSource={loading ? [] : rows}
        onRow={(record) => ({
          onClick: () => onRowClick && onRowClick(record),
        })}
        loading={loading}
        locale={{ ...loadingEmpty }}
        rowClassName={selectedRow &&hightlightRow}
        pagination={{
          showQuickJumper: true,
          defaultPageSize: 5,
          defaultCurrent: 1,
          total: loading ? 0 : rows?.length,
          showSizeChanger: false,
          size: "small",
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        }}
      />
    </div>
  );
};

export default DataTable;
